"use client";

import { useMaintenanceMode } from "@/hooks/use-statsig-config";

import { MaintenanceModeScreen } from "./maintenance-mode-screen";

/**
 * Client-side maintenance mode fallback.
 * The primary check happens server-side in layout.tsx.
 * This handles the case where maintenance mode is toggled on while the page is already open.
 */
export function MaintenanceModeHandler({ children }: { children: React.ReactNode }) {
  const { isMaintenanceMode, message } = useMaintenanceMode();
  if (isMaintenanceMode) return <MaintenanceModeScreen message={message} />;
  return children;
}
